export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Filter.vue?vue&type=template&id=461410f0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/Filter.vue?vue&type=template&id=461410f0&scoped=true
// module id = 2299
// module chunks = 31